import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

// Components
import Bacs from './bacs'

const Products = ({ slice }) => {
  const data = useStaticQuery(graphql`
    {
      allStripePrice(filter: { active: { eq: true }, type: { eq: "recurring" } }) {
        edges {
          node {
            currency
            id
            recurring {
              interval
            }
            unit_amount_decimal
          }
        }
      }
    }
  `)

  const prices = data.allStripePrice.edges.reduce((result, stripePrice) => {
    const id = stripePrice.node.id
    result[id] = { id, currency: stripePrice.node.currency, price: stripePrice.node.unit_amount_decimal * 0.01, recurringInterval: stripePrice.node.recurring.interval }
    return result
  }, {})

  return (
    <section className='max-w-7xl mx-auto py-10 md:py-20 px-4 sm:px-6 lg:px-8'>
      <div className='px-4 text-5xl tracking-tight leading-none font-serif text-gray-900 dark:text-white sm:text-center'>
        <PrismicRichText field={slice.primary.title.richText} />
      </div>

      <div className='px-4 my-5 sm:text-center prose dark:prose-invert min-w-full prose-lg'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      <ul className='md:grid grid-cols-3 gap-4 md:mt-12 mt-3 space-y-3 md:space-y-0'>
        {slice.items.map((product, index) => {
          return (
            <li
              key={`product-${index}`}
              className='component-product border border-gray-200 dark:border-gray-900 rounded-lg shadow-sm divide-y dark:shadow-gray-700/50 divide-gray-200 dark:bg-gray-700 dark:divide-gray-900 relative flex flex-col flex-1 bg-white'>
              <div className='p-6'>
                {product.title && <h2 className='text-2xl tracking-tighter leading-tight font-sans font-semibold'>{product.title}</h2>}
                {product.intro && <p className='mt-4 text-gray-700 dark:text-gray-300'>{product.intro}</p>}
                {product.stripe_price_id && (
                  <>
                    <p className='mt-8'>
                      <span className='text-4xl font-extrabold text-gray-900 dark:text-white'>£{prices[product.stripe_price_id].price?.toLocaleString()}</span>
                      {prices[product.stripe_price_id].recurringInterval && <span className='text-base font-semibold text-gray-700'>/{prices[product.stripe_price_id].recurringInterval}</span>}
                    </p>
                    <Bacs stripePriceId={prices[product.stripe_price_id].id} buttonText={product.button_text} />
                  </>
                )}
              </div>
              <div className='pt-6 pb-8 px-6'>
                {product.text.html && (
                  <div className='prose dark:prose-invert'>
                    <PrismicRichText field={product.text.richText} />
                  </div>
                )}
              </div>
            </li>
          )
        })}
        <li className='border border-gray-200 dark:border-gray-900 dark:bg-gray-700 dark:shadow-gray-700/50 rounded-lg shadow-sm divide-y divide-gray-200 col-span-3 text-center bg-white'>
          <div className='prose prose-lg dark:prose-invert min-w-full p-6'>
            <PrismicRichText field={slice.primary.footer_text.richText} />
          </div>
        </li>
      </ul>
    </section>
  )
}

export default Products
